<template>
	<v-card flat>
		<v-card-text>

			<clients-select v-if="!isClient || isClientManager" label="בחר לקוח" v-model="filters.client_id" :disable="isClientManager"/>

			<branches-select v-if="filters.client_id" lazy="client_id" ref="brachInput" :filters="{client_id: filters.client_id}" v-model="filters.branch_id"/>

			<v-select :items="monthDayItems" v-model="dayOrMonth" @change="updateIsMonth"></v-select>

			<v-date-picker v-if="choosingDay" full-width show-current v-model="filters.month" type="date"></v-date-picker>
			<v-date-picker v-else full-width v-model="filters.month" type="month" color="green lighten-1" header-color="primary"></v-date-picker>

			<smart-input required label="שם קובץ" v-model="filters.file_name"></smart-input>

		</v-card-text>
		<v-card-actions>
			<v-btn slot="actions" :disabled="!canExport" color="success" btn @click="exportExcel">
				{{ $t("pages.measurementTable.exportExcel") }}
			</v-btn>
			<v-spacer/>
			<v-btn slot="actions" v-if="isAdmin" :disabled="!canExport" color="warning" btn @click="reCalculate">
				בצע חישוב מחדש
			</v-btn>
			<v-spacer/>
			<v-btn slot="actions" v-if="isAdmin" @click="exportExcel" :disabled="!canExportForAll">יצוא קובץ של כלל הלקוחות</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
	import ClientsSelect from "dev/view/clients/ClientsSelect";
	import BranchesSelect from "dev/view/branches/BranchesSelect";
	import MeasurementService from "dev/services/MeasurementService";

	export default {
		name: "client-monthly-report",
		props: [],
		components: {BranchesSelect, ClientsSelect},
		data() {
			return {
				filters: {client_id: null, branch_id: null, isMonth: this.isMonth, month: null, file_name: "דוח לקוח"},
				monthDayItems: ["יום", "חודש"],
				dayOrMonth: "יום",

			};
		},
		computed: {
			clientId() {
				return this.$store.getters.ClientId;
			},

			isClientManager() {
				return this.$store.getters.isClientManager;
			},
			isAdmin() {
				return this.$store.getters.isAdmin;
			},

			isRole() {
				return this.$store.getters.isRole;
			},

			isClient() {
				return this.$store.getters.isClient;
			},
			basicUrl() {
				return this.$store.state.ConfigModule.request.baseUrl;
			},
			canExport() {
				return this.filters.month && (this.isClient || this.filters.client_id);
			},
			canExportForAll(){
				return this.filters.month && !this.filters.client_id;
			},
			choosingDay() {
				return (this.dayOrMonth === "יום");
			},
			isMonth() {
				return (!this.choosingDay);
			},
			clients(){
				return this.$store.state.ClientModule.clients;
			}
		},
		methods: {
			exportExcel() {
				let queryString = Object.keys(this.filters).filter(key => this.filters[key]).map(key => key + "=" + this.filters[key]).join("&");
				window.open(`${this.basicUrl}/export/measurement?a=1&${queryString}`);
			},
			async reCalculate() {
				let title = "אזהרה";
				let text = "כל המידע יחושב מחדש לפי התמחור המופיע ברגע זה במערכת!";
				swal.fire({
					title,
					text,
					type: "warning",
					showCancelButton: true,
					showLoaderOnConfirm: true,
					preConfirm: async (login) => {
						try {
							return await MeasurementService.reCalculate(this.filters);
						} catch (e) {
							throw Error();
						}

					},
				}).then(({value}) => {
					swal.fire("בצוע בהצלחח", `${value.projects.length} פרוייקטים עודכנו בהצלחה`, "success");
				}
				).catch(() => {
					swal.fire("תקלה", "תקלה בחישוב", "error");
				});
			},
			updateIsMonth() {
				this.filters.isMonth = this.isMonth;
			}
		},


		created() {
			//this.reCalculate();
			if (this.isClientManager) {
				this.filters.client_id = this.clientId;
			}


		}

	};
</script>

<style scoped>

</style>
